import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import useConfigAuth from '../../../Hooks/useConfigAuth';
import BotoneraBottom from '../Compartidos/BotoneraBottom';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import {Ilustracion, Flex, YellowBtn} from '../../Css/MetodosCSS/StyledCCSilabica';
import { AvanzarBtn, AvanzarImg } from '../../Css/StyledMatematica';

const instrucciones = 'Vamos a ver en la pantalla un dibujo. Tenemos que contar cuántas sílabas tiene, es decir, cuántas partes. Veamos juntos un ejemplo';
const miniInstrucciones = 'CUÁNTAS SÍLABAS TIENE';

const SCR2 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [indexes, setIndexes] = useState([]);
    const [resultado, setResultado] = useState([]);
    const [ejercicioElegido, setEjercicioElegido] = useState();

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const ayuda_imagen = useSelector((state) => state.configuracion.ayuda_imagen);

    const resultadoBase = [
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""}
    ];

    const verificar = (e) => {
        e.preventDefault();
        if(!ejercicioElegido){
            return;
        }
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.cantidad_silabas;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setEjercicioElegido('')
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        if(comparar.cantidad_silabas.toString() === ejercicioElegido.toString()) {
            console.log("bien");
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.cantidad_silabas;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "1";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setEjercicioElegido('')
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        } else {
            console.log('mal');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.cantidad_silabas;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setEjercicioElegido('')
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('SCR2') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length)
    }, [count, informacion])

    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])


    useEffect(() => {
        if(finalizar){

            const informacion = {
                config,
                payload: {
                'screening': true,
                'ejercicio': "SCR2",
                'resultado': resultado,
                'id_paciente': id_paciente
                }
            };

            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} ayuImagen={false} />
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%">
                    {comparar.ejemplo ? 
                    <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                        Ejemplo
                    </Flex>
                    : null
                    }
                    <Flex direction="column" margin="auto">
                        <Flex>
                            <Ilustracion src={`/img/${comparar.imagen_url_1}.png`} width="180px"/>
                            {ayuda_imagen ? 
                                <div>{comparar.ayuda_imagen_1}</div>
                            : null}
                        </Flex>
                        <Flex>
                            <YellowBtn width="80px" height="60px" margin="50px 5px" style={{border: ejercicioElegido === "1" ? "black" : null, borderColor: ejercicioElegido === "1" ? "black" : null, borderStyle: ejercicioElegido === "1" ? "solid" : null}}
                                disabled={disable}
                                onClick={() => setEjercicioElegido('1')}
                            >   
                                1
                            </YellowBtn>
                            <YellowBtn width="80px" height="60px" margin="50px 5px" style={{border: ejercicioElegido === "2" ? "black" : null, borderColor: ejercicioElegido === "2" ? "black" : null, borderStyle: ejercicioElegido === "2" ? "solid" : null}}
                                disabled={disable}
                                onClick={() => setEjercicioElegido('2')}
                            >   
                                2
                            </YellowBtn>
                            <YellowBtn width="80px" height="60px" margin="50px 5px" style={{border: ejercicioElegido === "3" ? "black" : null, borderColor: ejercicioElegido === "3" ? "black" : null, borderStyle: ejercicioElegido === "3" ? "solid" : null}}
                                disabled={disable}
                                onClick={() => setEjercicioElegido('3')}
                            >   
                                3
                            </YellowBtn>
                            <YellowBtn width="80px" height="60px" margin="50px 5px" style={{border: ejercicioElegido === "4" ? "black" : null, borderColor: ejercicioElegido === "4" ? "black" : null, borderStyle: ejercicioElegido === "4" ? "solid" : null}}
                                disabled={disable}
                                onClick={() => setEjercicioElegido('4')}
                            >   
                                4
                            </YellowBtn>
                            <YellowBtn width="80px" height="60px" margin="50px 5px" style={{border: ejercicioElegido === "5" ? "black" : null, borderColor: ejercicioElegido === "5" ? "black" : null, borderStyle: ejercicioElegido === "5" ? "solid" : null}}
                                disabled={disable}
                                onClick={() => setEjercicioElegido('5')}
                            >   
                                5
                            </YellowBtn>
                        </Flex>
                    </Flex>
                    <Flex margin="0 0rem 0 0rem" width="90%" justify="space-between" display="flex" align="center">
                        <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        <AvanzarBtn
                            disabled={disable}
                            onClick={(e) => verificar(e)}
                            
                        >
                            <AvanzarImg src={'/img/play.png'} /> 
                        </AvanzarBtn>
                    </Flex>
                </Flex>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR2;